/* eslint-disable */
import axios from "axios";
import store from "@/store";
import customModal from "../customModal/customModal.vue";
import KriDetailsModal from "./KriDetailsModal.vue";
import VPagination from "@hennge/vue3-pagination";
import manageKRIModal from "./ManageKRIModal.vue";

export default {
    name: "KriInfoModal",
    components: {
        customModal,
        VPagination,
        KriDetailsModal,
        manageKRIModal
    },
    props: {
        data: Object,
    },
    emits: ["closeModal"],

    data() {
        return {
            baseurl: process.env.VUE_APP_Service_URL,
            token: "",
            studyId: "",
            loading: false,
            kriList: [],
            currentPage: 1,
            pageSize: 10,
            totalCount: 0,
            totalPages: 1,
            selectedKriItem: null,
            showKriDetailsModal: false,
            openCreateRiskModal: false,
            riskEditData: null
        };
    },

    mounted() {
        this.studyId = store.getters.getStudyIs;
        this.token = store.getters.getIdToken;
        console.log("data", this.data)
        if (this.data) {
            this.fetchKriDetails();
        }
    },

    watch: {
        data: {
            deep: true,
            handler(newVal) {
                if (newVal) {
                    this.currentPage = 1;
                    this.fetchKriDetails();
                }
            },
        },
    },

    methods: {
        async fetchKriDetails(page = this.currentPage) {
            this.loading = true;
            this.kriList = [];

            try {
                const response = await axios.get(
                    `${this.baseurl}/forms/rbqm/paginatedkri`,
                    {
                        params: {
                            StudyId: this.studyId,
                            CtqId: this.data.ctqid,
                            pageindex: page,
                            pagesize: this.pageSize,
                        },
                        headers: {
                            Authorization: `Bearer ${this.token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );

                const result = response.data;

                if (result.entities && Array.isArray(result.entities)) {
                    this.kriList = result.entities.map(i => ({ ...i, expanded: false }));
                    this.totalCount = result.totalCount || 0;
                    this.totalPages = Math.ceil(this.totalCount / this.pageSize);
                } else if (Array.isArray(result)) {
                    this.kriList = result.map(i => ({ ...i, expanded: false }));
                    this.totalCount = result.length;
                    this.totalPages = Math.ceil(this.totalCount / this.pageSize);
                } else if (result) {
                    this.kriList = [{ ...result, expanded: false }];
                    this.totalCount = 1;
                    this.totalPages = 1;
                }

                this.currentPage = page;
            } catch (error) {
                console.error("Error fetching KRI details:", error);
                this.kriList = [];
                this.totalCount = 0;
                this.totalPages = 0;
            } finally {
                this.loading = false;
            }
        },
        openManageKRIModal(item) {
            if (item) {
                this.riskEditData = { ...item };
            } else {
                this.riskEditData = {
                    ctqId: this.data?.ctqid || "",
                    ctqFactor: this.data?.ctqFactor || "",
                    category: this.data?.category || "",
                };
            }
            this.openCreateRiskModal = true;
        },
        closeKRIRiskModal() {
            this.openCreateRiskModal = false;
            this.riskEditData = null;
        },
        reloaddatagrid() {
            this.fetchKriDetails();
        },
        loadPage(page) {
            this.fetchKriDetails(page);
        },

        closeModal() {
            this.$emit("closeModal");
        },

        viewKriDetails(item) {
            this.selectedKriItem = item;
            this.showKriDetailsModal = true;
        },

        closeKriDetailsModal() {
            this.showKriDetailsModal = false;
            this.selectedKriItem = null;
        },
        truncate(text) {
            //if (!text) return "—";
            return text.length > 120 ? text.substring(0, 120) + "..." : text;
        },

        toggleExpand(item) {
            item.expanded = !item.expanded;
        },
    },
};